import { Link } from 'react-router';

import BrandLogo from '@/components/BrandLogo';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import type { LandingContent, LandingLanguage } from './landingContent';

interface LandingHeaderProps {
  language: LandingLanguage;
  brand: LandingContent['brand'];
  nav: LandingContent['nav'];
  onLoginClick: () => void;
}

export default function LandingHeader({
  language,
  brand,
  nav,
  onLoginClick,
}: LandingHeaderProps) {
  return (
    <header className="landing-header">
      <Link className="landing-header-brand" to={`/${language}`} aria-label={brand} reloadDocument>
        <BrandLogo language={language} decorative />
      </Link>
      <div className="landing-header-actions">
        <span className="landing-header-language-label" aria-hidden="true">
          {nav.languageLabel}
        </span>
        <LanguageSwitcher
          ariaLabel={nav.languageLabel}
          navigationMode="document"
        />
        <Link className="landing-header-sign-in" to="/login" onClick={onLoginClick}>
          {nav.signIn}
        </Link>
      </div>
    </header>
  );
}
